import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return(
    <SettingsMetaData propertyName={"ReturnStatus"} viewPropertyName={"Return Status"} />
  )
};

export default Status;
